const userLocale = document.documentElement.lang || 'sv'; // Fallback to 'sv'
console.log('User Locale:', userLocale);

function removeTrailingZeros() {
    requestAnimationFrame(() => { // Use requestAnimationFrame for smoother performance
        const priceElements = document.querySelectorAll('[data-product-price], [data-product-unit-price], .product__price, [class-money]');
        priceElements.forEach(function(el) {
            let priceText = el.textContent.trim();
            if (userLocale === 'sv') {
                priceText = priceText.replace(/,00(?=\s|$)/g, '');
            } else {
                priceText = priceText.replace(/\.00(?=\s|$)/g, '');
            }
            el.textContent = priceText;
        });
    });
}

function observeMultipleElements() {
    const grids = document.querySelectorAll('.collection__products, .cart__drawer');

    if (grids.length === 0) {
        console.warn('No target elements found!');
        return;
    }

    const observer = new MutationObserver((mutationsList) => {
        let changesDetected = false;

        for (const mutation of mutationsList) {
            if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                changesDetected = true;
                break;
            }
        }

        if (changesDetected) {
            console.log('🔔 New content added via AJAX, removing trailing zeros...');
            setTimeout(removeTrailingZeros, 200); // Add slight delay for Safari rendering
        }
    });

    grids.forEach(grid => {
        observer.observe(grid, {
            childList: true,
            subtree: true
        });
        console.log(`✅ Observer attached to: ${grid.className}`);
    });

    setTimeout(removeTrailingZeros, 500); // Ensure initial cleanup after DOM loads
}

// Run once on initial load
document.addEventListener('DOMContentLoaded', () => {
    setTimeout(observeMultipleElements, 500); // Delay observer setup to avoid Safari crashes
});

// Handle variant change
document.addEventListener('variant:change', removeTrailingZeros);
